module.exports = __webpack_public_path__ + "img/08投标.325933f0.jpg";